module.exports = __webpack_public_path__ + "static/media/key-Energy.493e2d10.png";